import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from './AbstractList.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import {
  copyToArray2j022khrow2yi as copyToArray,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from './collectionJs.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { indexOf3ic8eacwbbrog as indexOf } from './_Arrays.mjs';
import { arrayToString1r7op7afgkivw as arrayToString } from './collectionsHacks.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from './Collections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(0);
        this_0.isReadOnly_1 = true;
        tmp.Empty_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function increaseLength($this, amount) {
  var previous = $this.get_size_woubt6_k$();
  // Inline function 'kotlin.js.asDynamic' call
  $this.array_1.length = $this.get_size_woubt6_k$() + amount | 0;
  return previous;
}
function rangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.checkElementIndex_s0yg86_k$(index, $this.get_size_woubt6_k$());
  return index;
}
function insertionRangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.checkPositionIndex_w4k0on_k$(index, $this.get_size_woubt6_k$());
  return index;
}
var ArrayListClass;
function ArrayList() {
  if (ArrayListClass === VOID) {
    class $ extends AbstractMutableList() {
      constructor(array) {
        return new.target.new_kotlin_collections_ArrayList_qfbsh5_k$(array);
      }
      static new_kotlin_collections_ArrayList_qfbsh5_k$(array) {
        Companion_getInstance();
        var $this = this.new_kotlin_collections_AbstractMutableList_ddn594_k$();
        $this.array_1 = array;
        $this.isReadOnly_1 = false;
        return $this;
      }
      static new_kotlin_collections_ArrayList_ony0vx_k$() {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        return this.new_kotlin_collections_ArrayList_qfbsh5_k$(tmp$ret$0);
      }
      static new_kotlin_collections_ArrayList_tdd6ob_k$(initialCapacity) {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        var $this = this.new_kotlin_collections_ArrayList_qfbsh5_k$(tmp$ret$0);
        // Inline function 'kotlin.require' call
        if (!(initialCapacity >= 0)) {
          var message = 'Negative initial capacity: ' + initialCapacity;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
      static new_kotlin_collections_ArrayList_nk3udn_k$(elements) {
        Companion_getInstance();
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$0 = copyToArray(elements);
        return this.new_kotlin_collections_ArrayList_qfbsh5_k$(tmp$ret$0);
      }
      build_nmwvly_k$() {
        this.checkIsMutable_jn1ih0_k$();
        this.isReadOnly_1 = true;
        return this.get_size_woubt6_k$() > 0 ? this : Companion_getInstance().Empty_1;
      }
      trimToSize_dmxq0i_k$() {
      }
      ensureCapacity_wr7980_k$(minCapacity) {
      }
      get_size_woubt6_k$() {
        return this.array_1.length;
      }
      get_c1px32_k$(index) {
        return this.array_1[rangeCheck(this, index)];
      }
      set_82063s_k$(index, element) {
        this.checkIsMutable_jn1ih0_k$();
        rangeCheck(this, index);
        // Inline function 'kotlin.apply' call
        var this_0 = this.array_1[index];
        this.array_1[index] = element;
        return this_0;
      }
      add_utx5q5_k$(element) {
        this.checkIsMutable_jn1ih0_k$();
        // Inline function 'kotlin.js.asDynamic' call
        this.array_1.push(element);
        this.modCount_1 = this.modCount_1 + 1 | 0;
        return true;
      }
      add_dl6gt3_k$(index, element) {
        this.checkIsMutable_jn1ih0_k$();
        // Inline function 'kotlin.js.asDynamic' call
        this.array_1.splice(insertionRangeCheck(this, index), 0, element);
        this.modCount_1 = this.modCount_1 + 1 | 0;
      }
      addAll_h3ej1q_k$(elements) {
        this.checkIsMutable_jn1ih0_k$();
        if (elements.isEmpty_y1axqb_k$())
          return false;
        var offset = increaseLength(this, elements.get_size_woubt6_k$());
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var _iterator__ex2g4s = elements.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          var index_0 = checkIndexOverflow(_unary__edvuaz);
          this.array_1[offset + index_0 | 0] = item;
        }
        this.modCount_1 = this.modCount_1 + 1 | 0;
        return true;
      }
      removeAt_6niowx_k$(index) {
        this.checkIsMutable_jn1ih0_k$();
        rangeCheck(this, index);
        this.modCount_1 = this.modCount_1 + 1 | 0;
        var tmp;
        if (index === get_lastIndex(this)) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.array_1.pop();
        } else {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.array_1.splice(index, 1)[0];
        }
        return tmp;
      }
      removeRange_sm1kzt_k$(fromIndex, toIndex) {
        this.checkIsMutable_jn1ih0_k$();
        this.modCount_1 = this.modCount_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        this.array_1.splice(fromIndex, toIndex - fromIndex | 0);
      }
      clear_j9egeb_k$() {
        this.checkIsMutable_jn1ih0_k$();
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.array_1 = [];
        this.modCount_1 = this.modCount_1 + 1 | 0;
      }
      indexOf_si1fv9_k$(element) {
        return indexOf(this.array_1, element);
      }
      toString() {
        return arrayToString(this.array_1);
      }
      toArray_jjyjqa_k$() {
        return [].slice.call(this.array_1);
      }
      toArray() {
        return this.toArray_jjyjqa_k$();
      }
      checkIsMutable_jn1ih0_k$() {
        if (this.isReadOnly_1)
          throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
    }
    initMetadataForClass($, 'ArrayList', $.new_kotlin_collections_ArrayList_ony0vx_k$, VOID, [KtMutableList(), RandomAccess()]);
    ArrayListClass = $;
  }
  return ArrayListClass;
}
//region block: exports
export {
  ArrayList as ArrayList3it5z8td81qkl,
};
//endregion

//# sourceMappingURL=ArrayListJs.mjs.map
